import { create } from "zustand";
import { TimeLineItem } from "../api/transformers/aml";
import { AmlAPI } from "../api";

export type TimeLineStore = {
  data: TimeLineItem[] | null;
  loading: boolean;
  error: unknown | null;
  fetchData: (personId: string) => void;
};

const useTimeLineStore = create<TimeLineStore>((set) => ({
  data: null,
  loading: true,
  error: null,
  // actions
  fetchData: async (personId) => {
    set({ loading: true, error: null, data: null });
    try {
      const result = await AmlAPI.getTimeLine(personId);
      set({ data: result, loading: false });
    } catch (err) {
      console.error(err);
      set({ error: err, loading: false });
    }
  },
}));

export default useTimeLineStore;
